export const PRODUCT_REQUEST="PRODUCT_REQUEST"
export const PRODUCT_SUCCESS="PRODUCT_SUCCESS"
export const PRODUCT_FAIL="PRODUCT_FAIL"